import View from "backdraft-app/src/view";

class InputView extends View {
  constructor(options) {
    options = options || {};

    const { render, ...optionsWithoutRender } = options;
    super(optionsWithoutRender);

    if (render) {
      this.render = this._wrapUserRender(render);
    }
  }

  initialize(options) {
    super.initialize(options);

    this.options = options;
  }

  render() {
    this.beforeRender();
    this.afterRender();
    return this;
  }

  beforeRender() {
    // to be implemented by subclasses
  }

  afterRender() {
    // to be implemented by subclasses
  }

  // this method wraps a user provided render method with a call to our required
  // before/after render methods, guaranteeing they will both be called
  _wrapUserRender(userRender) {
    return function() {
      this.beforeRender();
      userRender.apply(this, arguments);
      this.afterRender();
      return this;
    };
  }
}

export default InputView;
